// 中英文切换按钮:用于导航栏 / sidebar 头部
import React from 'react';
import { useI18n } from '../i18n';
import './LangSwitcher.css';

const LangSwitcher = ({ variant = 'navbar' }) => {
  const { lang, setLang } = useI18n();
  const other = lang === 'zh-CN' ? 'en-US' : 'zh-CN';
  const label = lang === 'zh-CN' ? 'EN' : '中';
  return (
    <button
      type="button"
      className={`lang-switcher lang-switcher--${variant}`}
      onClick={() => setLang(other)}
      title={other === 'zh-CN' ? '切换到中文' : 'Switch to English'}
      aria-label="切换语言"
    >
      <span className="lang-switcher__icon" aria-hidden="true">🌐</span>
      <span className="lang-switcher__label">{label}</span>
    </button>
  );
};

export default LangSwitcher;